import vmClient from 'app/services/vmClient';
import { IWordSentence, WordSentence } from 'app/constants/schemas/WordSentence';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface IVocabListWordSentence extends IEntity {
  attributes: {
    id: EntityStringId;
  };
  associations: {
    wordSentence: IWordSentence;
  };
}

export type VocabListWordSentence = Entity<IVocabListWordSentence>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabListWordSentence: IEntityType<IVocabListWordSentence> = vmClient.defineClass({
  typeName: 'VocabListWordSentence',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {},
  associations: {
    wordSentence: {
      type: WordSentence,
      notNull: true,
      shared: true,
    },
  },
});
